import { performRequest, performRequestFourth, performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';

import { getApiIdFromAppUrl, getTenantDetails } from 'utils/utils';
import { AppConfig } from 'config/api_config';

export const listEventTypes = (obj) => {
  const {
    pageLimit = 10,
    pagination_token = '',
    pagination_direction = 'forward',
    excludeFromLoading = false,
    practiceAreaId = [],
    sort_order = 'alphabet_ascending',
  } = obj;

  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${
    apiEndPoints.calendar.listEventTypes
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&practice_area_id=${
    practiceAreaId ? practiceAreaId : ''
  }&sort_order=${sort_order}`;
  return performRequest(apiEndPoints.methodType.GET, url, null, '', true, excludeFromLoading);
};

export const listEvents = (obj) => {
  const {
    event_type = '',
    attendee = '',
    category_filter = '',
    location = '',
    date_filter_param = '',
    range_end_param = '',
    case_id = '',
    limit = 1000,
    practice_area = '',
    user_timezone = '',
    data,
    list_google_calendars = false,
    conference_room = '',
  } = obj;
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${
    apiEndPoints.calendar.listEvents
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&event_type=${event_type}&attendee=${attendee}&category_filter=${
    category_filter ? category_filter : ''
  }&practice_area=${
    practice_area ? practice_area : ''
  }&location=${location}&limit=${limit}&date_filter_param=${date_filter_param}&range_end_param=${range_end_param}&case_id=${
    case_id ? case_id : ''
  }&user_timezone=${user_timezone ? user_timezone : ''}&list_google_calendars=${list_google_calendars}&conference_room=${
    conference_room ? conference_room : ''
  }`;
  return performRequest(apiEndPoints.methodType.POST, url, data);
};

export const calenderUserList = (obj) => {
  const { caseId, is_person, all_contacts = false, contact_id = false, is_team_member_list = false } = obj;
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.userList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${caseId ? `&case_id=${caseId}` : ''}${
    all_contacts ? `&all_contacts=${all_contacts}` : ''
  }${is_person ? `&is_person=${is_person}` : ''}${is_team_member_list ? `&is_team_member_list=${is_team_member_list}` : ''}`;
  if (contact_id) url = url + '&contact_id=' + contact_id;

  return performRequest(apiEndPoints.methodType.GET, url);
};

export const createEventType = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.createEventType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequest(apiEndPoints.methodType.POST, url, data);
};

export const getEvent = (event_id, selectedEvent, excludeFromLoading = false) => {
  let sk = encodeURIComponent(selectedEvent?.extendedProps?.sk || '');
  let is_recurring = selectedEvent?.extendedProps?.is_recurring ?? '';
  let overriden_start_date = selectedEvent?.extendedProps?.meeting_start_time || '';
  let overriden_end_date = selectedEvent?.extendedProps?.meeting_end_time || '';
  let is_clone = selectedEvent?.extendedProps?.is_clone || '';

  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.getEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&sk=${sk}${
    event_id ? `&event_id=${event_id}` : ''
  }&overriden_start_date=${overriden_start_date}&overriden_end_date=${overriden_end_date}&is_recurring=${is_recurring}&is_clone=${is_clone}`;
  return performRequest(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
};

export const addEvent = (obj) => {
  const { data, case_id = '', is_lead = false, timeEntryData = '' } = obj;
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);

  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.createEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  url += case_id ? `&case_id=${case_id}` : '';
  url += is_lead ? `&is_lead=${is_lead}` : '';
  url += `&apiId=${apiId}`;
  return performRequest(apiEndPoints.methodType.POST, url, data, timeEntryData);
};

export const updateEvent = (obj) => {
  const {
    reminder_updated,
    send_update_notification,
    data,
    case_id = '',
    is_lead = false,
    timeEntryData = '',
    recurrence_scope = '',
    overriden_start_date,
    isPrevEventRecurring = false,
    is_date_changed = false,
  } = obj;
  const [tenantId, tenantSk] = getTenantDetails();
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);

  let url = '';
  if (isPrevEventRecurring === true) {
    url = `${apiEndPoints.calendar.updateEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
    url += case_id ? `&case_id=${case_id}` : '';
    url += `&is_reminder_updated=${reminder_updated}&send_update_notification=${send_update_notification}`;
    url += is_lead ? `&is_lead=${is_lead}` : '';
    url += `&overriden_start_date=${overriden_start_date}&recurrence_scope=${recurrence_scope}&is_date_changed=${is_date_changed}&apiId=${apiId}`;

    return performRequest(apiEndPoints.methodType.PUT, url, data, timeEntryData);
  } else {
    url = `${apiEndPoints.calendar.updateEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
    url += case_id ? `&case_id=${case_id}` : '';
    url += `&is_reminder_updated=${reminder_updated}&send_update_notification=${send_update_notification}`;
    url += is_lead ? `&is_lead=${is_lead}` : '';
    url += `&apiId=${apiId}`;

    return performRequest(apiEndPoints.methodType.PUT, url, data, timeEntryData);
  }
};

export const deleteEvent = (obj) => {
  const [tenantId, tenantSk] = getTenantDetails();

  if (obj?.data?.is_recurring === true) {
    let { is_lead = false, recurrence_scope = '', overriden_start_date, timeEntryData = '', pk } = obj;
    pk = pk ? pk.replaceAll('#', '%23') : '';
    let url = `${apiEndPoints.calendar.deleteEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }&overriden_start_date=${overriden_start_date}&recurrence_scope=${recurrence_scope}`;

    // console.log("delete new url ", url)
    // return null
    return performRequest(apiEndPoints.methodType.DELETE, url, {}, timeEntryData);
  } else {
    let { pk, is_lead = false, timeEntryData = '' } = obj;
    pk = pk ? pk.replaceAll('#', '%23') : '';
    let url = `${apiEndPoints.calendar.deleteEvent}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }`;

    //  console.log("delete old url ", url)
    //  return null
    return performRequest(apiEndPoints.methodType.DELETE, url, {}, timeEntryData);
  }
};

export const updateCalendarSettings = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.updateSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestFourth(apiEndPoints.methodType.PUT, url, data);
};

export const getCalendarSettings = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.getSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequest(apiEndPoints.methodType.GET, url);
};

export const getFreeTime = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.getFreeTime}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data, null, true, true);
};

export const getSideBarUsers = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.calendar.getSideBarUsers}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data, null, true, true);
};

// Google calnder service

export const generateAuthURl = (firm_user_id) => {
  const [tenantId] = getTenantDetails();
  let url = `${apiEndPoints.calendar.generateAuthUrl}?tenant_id=${tenantId}&firm_user_id=${firm_user_id}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const generateToken = (firm_user_id, code, state) => {
  const [tenantId] = getTenantDetails();
  let url = `${apiEndPoints.calendar.generateToken}?tenant_id=${tenantId}&firm_user_id=${firm_user_id}&code=${code}&state=${state}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const disconnectCalendar = (firm_user_id) => {
  const [tenantId] = getTenantDetails();
  let url = `${apiEndPoints.calendar.generateToken}?tenant_id=${tenantId}&firm_user_id=${firm_user_id}&disconnect_connection=true`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};
/**
 * Fetch events using the v2 API
 * Supports year, month, week, and day views
 *
 * @param {object} params - API parameters
 * @param {string} params.view - View type: 'year', 'month', 'week', 'day'
 * @param {string} params.timezone - User timezone (e.g., 'America/Chicago')
 * @param {string} [params.year] - Year for year view (e.g., '2025')
 * @param {string} [params.startUTC] - Start date/time in ISO 8601 format (UTC)
 * @param {string} [params.endUTC] - End date/time in ISO 8601 format (UTC)
 * @param {array} [params.userIds] - Array of user IDs to filter
 * @param {number} [params.limitPerDay] - Events to return per day for month view (default: 2)
 * @returns {Promise<{data: object|array}>} Events data
 */
export const getCalendarEventsV2 = async ({
  view,
  timezone,
  year,
  startUTC,
  endUTC,
  userIds = [],
  limitPerDay = 2,
  case_id = null,
  contact_id = null,
  filters = {},
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  // Build query parameters
  const queryParams = new URLSearchParams({
    tenant_id: tenantId,
    tenant_sk: tenantSk,
    view: view,
    tz: timezone || 'UTC',
    case_id: case_id || '',
    contact_id: contact_id || '',
  });

  // Add view-specific params
  if (view === 'year' && year) {
    queryParams.append('year', year);
  } else if (['month', 'week', 'day', 'agenda'].includes(view)) {
    if (startUTC) queryParams.append('start_utc', startUTC);
    if (endUTC) queryParams.append('end_utc', endUTC);
  }

  // Build request body
  const requestBody = {
    users: userIds,
    location: filters?.location?.value,
    practice_area: filters?.practice_area?.value,
    event_type: filters?.event_type?.value,
    conference_room_id: filters?.conference_room_id?.value,
    show_firm_events: filters?.show_firm_events,
    calendar_type: filters?.calendar_type,
  };

  // Add limit_per_day for month view
  if (view === 'month') {
    requestBody.limit_per_day = limitPerDay;
  }

  const url = `${apiEndPoints.calendar.listEventsV2}?${queryParams.toString()}`;

  return performRequestSecond(apiEndPoints.methodType.POST, url, requestBody, '', true, true);
};
